import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { elevationColor } from "../helperFunctions/elevationColor";

// Legend for the "Visualize Elevation" view: a blue→red gradient bar with the
// min/max elevation of the current network. `metric` names the displayed
// elevation: "ground" (terrain) or "invert" (result view only).
export const ElevationLegend = ({ range, metric = "ground" }) => {
  const { t } = useTranslation();
  if (!range) return null;
  const { min, max } = range;

  const stops = [0, 0.25, 0.5, 0.75, 1].map((f) =>
    elevationColor(min + f * (max - min), min, max)
  );
  const gradient = `linear-gradient(to top, ${stops.join(", ")})`;
  const fmt = (v) => `${Math.round(v)} m`;

  return (
    <Box
      className="absolute right-4 top-1/2 -translate-y-1/2 flex items-stretch gap-2 p-2 rounded"
      sx={{
        zIndex: 9999,
        backgroundColor: "rgba(255,255,255,0.9)",
        boxShadow: 2,
      }}
    >
      <Box className="flex flex-col justify-between items-end h-32">
        <Typography variant="caption">{fmt(max)}</Typography>
        <Typography variant="caption" sx={{ fontWeight: 600 }}>
          {t(metric === "invert" ? "Invert Elevation" : "Ground Elevation")}
        </Typography>
        <Typography variant="caption">{fmt(min)}</Typography>
      </Box>
      <Box
        sx={{
          width: 14,
          borderRadius: "3px",
          background: gradient,
          border: "1px solid rgba(0,0,0,0.2)",
        }}
      />
    </Box>
  );
};
